import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import LoadingOverlay from "../../../helpers/LoadingOverlay/LoadingOverlay";
import CustomInput from "../../../components/CustomInput/CustomInput";
import {
  addRole,
  getMenusList,
} from "../../../redux/UsersManagement/Roles/rolesSlice";

function AddRole() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addRoleFormValues, menusList, isLoading } = useSelector(
    (state) => state.roles
  );

  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    reset,
    control,
  } = useForm({
    defaultValues: addRoleFormValues,
  });

  useEffect(() => {
    reset(addRoleFormValues);
  }, [addRoleFormValues]);

  // Get Menus List
  useEffect(() => {
    dispatch(getMenusList());
  }, []);

  const handleAddRole = (data) => {
    dispatch(addRole(data)).then((res) => !res.error && navigate("/Roles"));
  };

  return (
    <>
      <nav className="uk-position-relative" aria-label="Breadcrumb">
        <ul className="uk-breadcrumb">
          <li>
            <NavLink to="/Users">المستخدمين</NavLink>
          </li>
          <li>
            <NavLink to="/Roles">الأدوار</NavLink>
          </li>
          <li>
            <span aria-current="page">إضافة دور</span>
          </li>
        </ul>
      </nav>

      {isLoading ? (
        <LoadingOverlay />
      ) : (
        <div className="uk-padding-small uk-background-default uk-border-rounded">
          <form className="uk-grid-small uk-child-width-1-3" uk-grid="">
            <div>
              <label className="uk-form-label uk-text-gray uk-text-bold">
                اسم الدور
              </label>
              <div className="uk-form-controls uk-margin-small-top">
                <CustomInput
                  control={control}
                  name="roleName"
                  error={errors.roleName}
                />
              </div>
            </div>

            <h4 className="uk-heading-line uk-margin-medium-top uk-margin-small-bottom uk-width-1-1 uk-text-bold">
              <span>الصلاحيات</span>
            </h4>

            {/* Load All Menus List */}
            {menusList.map((item) => (
              <div key={item.id} className="uk-form-controls">
                <input
                  className="uk-checkbox"
                  type="checkbox"
                  value={item.id}
                  {...register(`menusList`)}
                />
                {item.name}
              </div>
            ))}
          </form>
          <div className="uk-margin-top uk-text-left">
            <button
              className="uk-button uk-button-secondary uk-margin-small-left uk-border-rounded"
              type="button"
              disabled={!isValid || isLoading}
              onClick={handleSubmit(handleAddRole)}
            >
              {isLoading ? <div uk-spinner="ratio: 0.5"></div> : "إضافه"}
            </button>
            <NavLink
              to="/Roles"
              className="uk-button uk-button-primary uk-modal-close uk-border-rounded"
              type="button"
            >
              إلغاء
            </NavLink>
          </div>
        </div>
      )}
    </>
  );
}

export default AddRole;
